import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ViewsComponent } from './views/views.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./views/views.module').then(m => m.ViewsModule) },
];

@NgModule({
  // scrollPositionRestoration resets to the top on a new navigation (without it the
  // router leaves the scroll offset alone, so following a footer link opened the
  // policy pages part-way down) and restores the previous offset on back/forward.
  // anchorScrolling lets in-page fragment links — the privacy policy's section links —
  // scroll to their target; it takes precedence when the URL carries a fragment.
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
